<template>
  <div class="Body">
   <router-view v-if="isRouterAlive" />
   <div v-if="UserInfo.kf_link">
		<div id="whatsapp" v-if="UserInfo.danger==2 && UserInfo.kf_show==1 && UserInfo.vip_level>1">
			<img :src="`./static/images/whatsapp.png`" @click="openKefu(UserInfo.kf_link)" width="45" style="border-radius: 30px;">
			<!-- Whatsapp -->
		</div>
		<div id="whatsapp" v-if="UserInfo.danger==2 && UserInfo.kf_show==2 && UserInfo.vip_level==1">
			<img :src="`./static/images/whatsapp.png`" @click="openKefu(UserInfo.kf_link)" width="45" style="border-radius: 30px;">
			<!-- Whatsapp -->
		</div>
		<div id="whatsapp" v-if="UserInfo.danger==2 && UserInfo.kf_show==0" >
			<img :src="`./static/images/whatsapp.png`" @click="openKefu(UserInfo.kf_link)" width="45" style="border-radius: 30px;">
			<!-- Whatsapp -->
		</div>
   </div>

	<div id="Service" v-if="showService">
	  <img :src="InitData.setting.kefu_img" @click="openKefu(InitData.setting.service_url)" width="40" style="border-radius: 30px;">
	  <!-- {{$t('common[0]')}} -->
	</div>

  </div>
</template>

<script>
import EventBus from '@/utils/EventBus'
import FacebookPixel from '@/utils/FacebookPixel'
export default {
  name: 'App',
  provide () {
    return {
      reloadHtml: this.reloadHtml
    }
  },
  components: {

  },
  props: [],
  data() {
    return {
      percentNum: 0,
      showEntrance: false,
      networkState: 1,
      isQuit: false,
      isView: true,
      isRouterAlive: true,
      showNotice: false,
      isInit: false,
      translateX: '0',
      translateY: '-150',
      isCancel: false,
      showService: true,
    }
  },
  computed: {

  },
  watch: {
    '$route'(to, from) {
      this.isQuit = false;
      if(from.name=='line'){
        this.$Model.GetBackData()
      }
    },
    'UserInfo.kf_link'() {
      this.$nextTick(() => {
        this.bindFloatDrag()
      })
    },
  },
  created() {
    this.$Model.GetBackData()
    this.isInit = true
    // 监听Facebook像素初始化事件
    EventBus.$on('facebook-pixel-init', this.initFacebookPixel)
  },
  mounted() {
    $('body').on('click','#CloseAlert',()=>{
      this.$dialog.close();
    });
    /*APP初始化启动*/
    document.addEventListener("plusready", () => {
      document.addEventListener("pause", ()=>{
        this.isView = false
        console.log('后台')
      }, false);
      document.addEventListener("resume", ()=>{
        this.isView = true
        console.log('前台')
      }, false);
      document.addEventListener("newintent", ()=>{
        var args = plus.runtime.arguments;
        if(args){
          this.$router.push(args)
        }
        console.log(args)
      }, false);
      this.winH = document.body.clientHeight;
      plus.runtime.getProperty(plus.runtime.appid, wgtinfo => {
        localStorage["AppVersion"] = wgtinfo.version;
        checkUpdate(wgtinfo.version);
      });
      if (plus.os.name == "iOS") {
        iosBack();
      }
      plus.key.addEventListener("backbutton", () => {
        appBack();
      });
    });
    let retry = 0;
    var checkUrl = UpdateUrl[0];
    const checkUpdate = (wgtVer) => {
      $.ajax({
        url: checkUrl,
        dataType: "json",
        data: {
          version: wgtVer
        },
        timeout: 2000,
        success: data => {
          if(data.code==0){
            this.$Dialog.Confirm(data.code_dec,()=>{
              downWgt(data.url);
            })
          }
        },
        error: (xhr, type, errorThrown) => {
          retry+=1
          if(retry<2){
            checkUpdate(wgtVer)
          }else{
            if (checkUrl != UpdateUrl[1]) {
              retry = 0;
              checkUrl = UpdateUrl[1];
              checkUpdate(wgtVer)
            } else {
              console.log("网络错误，无法更新");
            }
          }
        }
      });
    };
    const downWgt = (wgtUrl) => {
      const downToast = this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: 'Ready to download the update...',
      });
      var task = plus.downloader.createDownload(wgtUrl,{filename: "_doc/update/"},(d, status) => {
            if (status == 200) {
              console.log("下载更新成功：" + d.filename);
              this.$toast.clear();
              this.$Dialog.Confirm('The download is complete, whether to install the update package',()=>{
                installWgt(d.filename);
              })
            } else {
              console.log("下载更新失败");
              this.$toast.fail('Failed to download update');
            }
          }
      );

      task.addEventListener("statechanged", (download, status) => {
        switch (download.state) {
          case 2:
            downToast.message = 'Downloaded0%';
          case 3:
            this.percentNum = parseInt(
                (download.downloadedSize / download.totalSize) * 100
            );
            downToast.message = 'Downloaded'+this.percentNum+'%';
            break;
          case 4:
            break;
        }
      });
      task.start();
    };
    const installWgt = path => {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: 'Updating...',
      });
      plus.runtime.install( path, {}, () => {
        console.log("安装更新文件成功");
        localStorage.clear();
        this.$toast.success({
          forbidClick: true,
          message: 'The update is successful and will restart soon',
          onClose() {
            plus.runtime.restart();
          }
        });
      }, e => {
        console.log("安装更新文件失败[" + e.code + "]：" + e.message);
        this.$toast.success('Update failed');
      });
    };
    const iosBack = () => {
      var startX = 0;
      var endX = 0;
      document.addEventListener(
          "touchstart",
          event => {
            if (event.targetTouches.length == 1) {
              var touch = event.targetTouches[0];
              startX = touch.screenX;
            }
          },
          { passive: false }
      );
      document.addEventListener(
          "touchend",
          event => {
            if (event.changedTouches.length == 1) {
              var touch = event.changedTouches[0];
              endX = touch.screenX;
              if (startX <= 20 && endX >= 80) {
                appBack();
              }
            }
          },
          { passive: false }
      );
    };
    const appBack = () => {
      if (
          this.$route.name == "home") {
        if (this.isQuit) {
          plus.runtime.quit();
          this.isReconnect = false
          this.Socket&&this.Socket.close();
        } else {
          this.$toast({
            message: "Press again to exit the app",
            position: "bottom"
          });
          this.isQuit = true;
        }
      } else {
        if ($(".van-nav-bar__left").length) {
          $(".van-nav-bar__left").click();
        } else {
          this.$router.go(-1);
        }
      }
    };
    // 拖动（元素可能因 v-if 尚未渲染，需判空）
    this.$nextTick(() => {
      this.bindFloatDrag()
    })
  },
  activated() {

  },
  destroyed() {
    // 清理EventBus监听器
    EventBus.$off('facebook-pixel-init', this.initFacebookPixel)
  },
  methods: {
    openKefu(url) {
      window.location.href = url;
    },
    reloadHtml () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    /**
     * 初始化Facebook像素
     * @param {string} pixelId - Facebook像素ID
     */
    initFacebookPixel(pixelId) {
      console.log('初始化Facebook像素:', pixelId)
      if (pixelId && pixelId !== 'null' && pixelId !== 'undefined') {
        FacebookPixel.init(pixelId)
      }
    },
    bindFloatDrag() {
      var obj = document.getElementById('Service');
      var whats = document.getElementById('whatsapp');
      var drag = false;
      var drag1 = false;
      var screenHeight = document.documentElement.clientHeight;
      var screenWidth = document.documentElement.clientWidth;
      var pageX = screenWidth;

      if (obj && !obj.dataset.dragBound) {
        obj.dataset.dragBound = '1';
        obj.addEventListener('touchstart', () => {
          drag = true;
          if (obj.setCapture) {
            obj.setCapture();
          }
          $('#Service').removeClass('move')
        });
        obj.addEventListener('touchmove', (ev) => {
          $('#Service').removeClass('move')
          ev.preventDefault();
          ev = ev.touches ? ev.touches[0] : event;
          if (drag) {
            if (ev.pageY < obj.clientHeight / 2) {
              obj.style.bottom = screenHeight - obj.clientHeight + 'px';
            } else if (ev.pageY > screenHeight - 5 - obj.clientHeight / 2) {
              obj.style.bottom = '5px';
            } else {
              obj.style.bottom = screenHeight - ev.pageY - obj.clientHeight / 2 + 'px';
            }
            if (ev.pageX < obj.clientWidth / 2) {
              obj.style.right = screenWidth - obj.clientWidth + 'px';
            } else if (ev.pageX > screenWidth - obj.clientWidth / 2) {
              obj.style.right = '0px';
            } else {
              obj.style.right = screenWidth - ev.pageX - obj.clientWidth / 2 + 'px';
            }
            pageX = ev.pageX
          }
        });
        obj.addEventListener('touchend', () => {
          drag = false;
          $('#Service').addClass('move')
          if (pageX > screenWidth / 2) {
            obj.style.right = 0;
          } else {
            obj.style.right = screenWidth - obj.clientWidth + 'px';
          }
        })
      }

      if (whats && !whats.dataset.dragBound) {
        whats.dataset.dragBound = '1';
        whats.addEventListener('touchstart', () => {
          drag1 = true;
          if (whats.setCapture) {
            whats.setCapture();
          }
          $('#whatsapp').removeClass('move')
        });
        whats.addEventListener('touchmove', (ev) => {
          $('#whatsapp').removeClass('move')
          ev.preventDefault();
          ev = ev.touches ? ev.touches[0] : event;
          if (drag1) {
            if (ev.pageY < whats.clientHeight / 2) {
              whats.style.bottom = screenHeight - whats.clientHeight + 'px';
            } else if (ev.pageY > screenHeight - 5 - whats.clientHeight / 2) {
              whats.style.bottom = '5px';
            } else {
              whats.style.bottom = screenHeight - ev.pageY - whats.clientHeight / 2 + 'px';
            }
            if (ev.pageX < whats.clientWidth / 2) {
              whats.style.right = screenWidth - whats.clientWidth + 'px';
            } else if (ev.pageX > screenWidth - whats.clientWidth / 2) {
              whats.style.right = '1rem';
            } else {
              whats.style.right = screenWidth - ev.pageX - whats.clientWidth / 2 + 'px';
            }
            pageX = ev.pageX
          }
        });
        whats.addEventListener('touchend', () => {
          drag1 = false;
          $('#whatsapp').addClass('move')
          if (pageX > screenWidth / 2) {
            whats.style.right = '1rem';
          } else {
            whats.style.right = screenWidth - whats.clientWidth + 'px';
          }
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
#whatsapp{
	position: absolute;
    bottom: 14rem;
    right: 1rem;
    z-index: 99;
    color: #999;
    line-height: 1;
    text-align: center;
    font-size: .75rem;
}
#whatsapp img {
    display: block;
    margin: 0 auto;
}
#Service{
  z-index: 999;
}
</style>